import Phaser from 'phaser';
import KeyGroup from '../KeyGroup';
import Key from '../Key';

const SoilState = {
    B_B: 1, 
    B_O: 2, 
    B_P: 3, 
    B_RA: 4, 
    B_RP: 5, 
    O_B: 6, 
    O_RA: 7, 
    O_RP: 8, 
    P_B: 9, 
    P_RA: 10, 
    P_RP: 11, 
    RA_B: 12, 
    RP_B: 13, 
    RA_O: 14, 
    RP_O: 15, 
    RA_RO_O: 16, 
    RP_RO_O: 17, 
    RA_RO_P: 18, 
    RP_RO_P: 19, 
    RA_RO: 20, 
    RP_RO: 21, 
    RO_RA_O: 22, 
    RO_RP_O: 23, 
    RO_RA_P: 24, 
    RO_RP_P: 25, 
    RO_RA: 26, 
    RO_RP: 27, 
    RA_P: 28, 
    RP_P: 29,
    START: 30
};

const Powerups = {
    NONE: -1,
    SWAP_CONTROLS: 0,
    OBFUSCATOR: 1,
    FREEZE: 2,
    IRON_TIP: 3,
    SHIELD: 4,
    //THIEF: 5,
    COIN: 6
}

const Direction = {
    LEFT: 0,
    RIGHT: 1
};

var PLAYERS = 4;
const style = { font: "44px Arial", fill: "#333300", align: "center" };
const style2 = { font: "44px Arial", fill: "#0000FF", align: "center" };

var airconsole;
var inputQueue;

// var text = game.add.text(game.world.centerX, game.world.centerY, "- phaser -\nwith a sprinkle of\npixi dust", style);

var menu = true;
var inited = false;
export default class GameScene extends Phaser.Scene
{
    menuImg?:Phaser.GameObjects.Image;
    numberOfPlayers?: number;
    playersCanAct?: boolean[];
    playersCanBeTarget?: boolean[];
    playersOnIronTip?: boolean[];
    playersScore?: number[];
    playersTextScore?: Phaser.GameObjects.Text[];
    playersStatus?: Phaser.GameObjects.Text[];
    playersSoil?: number[][];
    playersPastSoil?: number[][];
    playersCurrentsoil?: number[];
    playersPowerup?: number[];
    playersImagePowerup?: Phaser.GameObjects.Image[];
    playersKeyGroup?: KeyGroup[];
    playersPreviousDirection?: number[];
    playersCurrentDirection?: number[];
    stains?: Phaser.GameObjects.Image[];

    emitterHitO?: any;
    emitterEatO?: any;
    emitterPowerup?: any;

	constructor()
	{
		super({key:'game', active:true});
        inputQueue = new Array(4);
        for(var i=0;i<4;i++){
            inputQueue[i] = new Array();
        }
	}

    init( numberOfPlayers ) { //TO BE UNCOMMENTED LATER SO NUMBER OF PLAYERS IS PASSED FROM MENU TO HERE
        //this.numberOfPlayers = numberOfPlayers;
    }

    create() {
        this.menuImg = this.add.image(0,0,'menu').setOrigin(0,0).setScale(4).setInteractive();

        this.menuImg.on('pointerdown', function(pointer) {
            if(pointer.y < 86*4 || pointer.y > 131*4)
                return;
            else {
                if(pointer.x > 20*4 && pointer.x < 66*4) {
                    PLAYERS = 1;
                    inited = true;
                }
                else if(pointer.x > 98*4 && pointer.x < 144*4) {
                    PLAYERS = 2;
                    inited = true;
                }
                else if(pointer.x > 175*4 && pointer.x < 221*4) {
                    PLAYERS = 3;
                    inited = true;
                }
                else if(pointer.x > 252*4 && pointer.x < 297*4) {
                    PLAYERS = 4;
                    inited = true;
                }
            }
        });

            // =======================================================
            // Create AirConsole instance
            airconsole = new AirConsole();
            airconsole.onReady = function() {
                airconsole.setActivePlayers(4);
            };
            // As soon as a device connects we add it to our device-map
            airconsole.onConnect = function(device_id) {
                airconsole.setActivePlayers(4);
            };
            // Called when a device disconnects (can take up to 5 seconds after device left)
            airconsole.onDisconnect = function(device_id) {
            };
            // onMessage is called everytime a device sends a message with the .message() method
            airconsole.onMessage = function(device_id, data) {
                var playerId = airconsole.convertDeviceIdToPlayerNumber(device_id,);
                // We receive a message -> Send message back to the device
                airconsole.message(device_id, {"score": (0),"vibrate":50, "playerId": playerId});
                console.log("Player: "+ playerId + " - Key: " + data.key);
                inputQueue[playerId].push(data.key);
            };
            // =======================================================

    }

    fullCreate() {
        
        this.numberOfPlayers = PLAYERS; // TO BE REMOVED ONCE WE RECEIVE THIS PARAMETER VIA INIT
        
        // KEYS
        this.playersKeyGroup = new Array(PLAYERS);
        //for(var i = 0; i < this.playersKeyGroup.length; ++i) {
            //BECAUSE WE NOW KNOW THERE'S ONLY 1 PLAYER
        if(PLAYERS > 3)
        this.playersKeyGroup[3] = new KeyGroup( new Key(this.input.keyboard.addKey(Phaser.Input.Keyboard.KeyCodes.LEFT)),
                                                new Key(this.input.keyboard.addKey(Phaser.Input.Keyboard.KeyCodes.RIGHT)),
                                                new Key(this.input.keyboard.addKey(Phaser.Input.Keyboard.KeyCodes.SPACE)));
        if(PLAYERS > 0)
        this.playersKeyGroup[0] = new KeyGroup( new Key(this.input.keyboard.addKey(Phaser.Input.Keyboard.KeyCodes.Z)),
                                                new Key(this.input.keyboard.addKey(Phaser.Input.Keyboard.KeyCodes.X)),
                                                new Key(this.input.keyboard.addKey(Phaser.Input.Keyboard.KeyCodes.C)));

        if(PLAYERS > 1)
        this.playersKeyGroup[1] = new KeyGroup( new Key(this.input.keyboard.addKey(Phaser.Input.Keyboard.KeyCodes.N)),
                                                new Key(this.input.keyboard.addKey(Phaser.Input.Keyboard.KeyCodes.M)),
                                                new Key(this.input.keyboard.addKey(Phaser.Input.Keyboard.KeyCodes.COMMA)));
        if(PLAYERS > 2)
        this.playersKeyGroup[2] = new KeyGroup( new Key(this.input.keyboard.addKey(Phaser.Input.Keyboard.KeyCodes.OPEN_BRACKET)),
                                                new Key(this.input.keyboard.addKey(Phaser.Input.Keyboard.KeyCodes.CLOSED_BRACKET)),
                                                new Key(this.input.keyboard.addKey(Phaser.Input.Keyboard.KeyCodes.BACK_SLASH)));
        //}

        // POWERUPS
        this.playersPowerup = new Array(PLAYERS);
        for(var i = 0; i < this.playersPowerup.length; ++i) {
            this.playersPowerup![i] = Powerups.NONE;
        }
        this.playersImagePowerup = new Array(PLAYERS);

        // CAN ACT?
        this.playersCanAct = new Array(PLAYERS);
        for(var i = 0; i < PLAYERS; ++i ){
            this.playersCanAct[i] = true;
        }
        
        // SCORES
        this.playersScore = new Array(PLAYERS);
        for(var i = 0; i < this.playersScore!.length; ++i) {
            this.playersScore![i] = 0;
        }

        // SOIL PIECES
        const numberOfSoilParts:number = 1000;
        this.playersSoil = new Array(PLAYERS);

        for( var i = 0; i < this.playersSoil.length; ++i ) 
            this.playersSoil[i] = new Array(numberOfSoilParts);

        for( var i = 0; i < this.playersSoil.length; ++i ) {
            for( var j = 0; j < this.playersSoil[i].length; ++j ) {
                
                var s:number = Math.random() * 100;

                /**
                 * Soil 0       -> 60% of chance to be chosen, neither obstacles nor powerups
                 * Soil 1,2     -> 35% of chance to be chosen, obstacle eiher left (1) or right (2)
                 * Soil 3,4     -> 5% of chance to be chosen, powerup either left (3) or right (4) 
                 */
                const maxSoilFirstRange:number = 60;
                const maxSoilSecondRange:number = 95;

                if( s < maxSoilFirstRange ) {
                   this.playersSoil[i][j] = Number(SoilState.B_B);
                }
                else if( s < maxSoilSecondRange ) {
                    var sIsEven:boolean = (Math.floor(s) % 2 == 0);
                    this.playersSoil[i][j] = sIsEven ? SoilState.O_B : SoilState.B_O;
                }
                else {
                    var sIsEven:boolean = (Math.floor(s) % 2 == 0);
                    this.playersSoil[i][j] = sIsEven ? SoilState.P_B : SoilState.B_P;
                }
            }
        }
        
        this.playersPreviousDirection = new Array(PLAYERS);
        for(var i = 0; i < this.playersPreviousDirection.length; ++i)
            this.playersPreviousDirection![i] = Direction.LEFT;

        this.playersCurrentDirection = new Array(PLAYERS);
        for(var i = 0; i < this.playersCurrentDirection.length; ++i)
            this.playersCurrentDirection![i] = Direction.LEFT;

        this.playersPastSoil = new Array(PLAYERS);
        for(var i = 0; i < this.playersPastSoil!.length; ++i) {
            this.playersPastSoil![i] = new Array(2);
            this.playersPastSoil![i][1] = SoilState.START;
        }

        this.playersCurrentsoil = new Array(PLAYERS);
        for(var i = 0; i < this.playersCurrentsoil.length; ++i)
            this.playersCurrentsoil![i] = SoilState.RA_B;


        /*********************************************************************** */
        this.playersOnIronTip = new Array(PLAYERS);
        for( var i = 0; i < PLAYERS; ++i ) {
            this.playersOnIronTip[i] = false;
        }
        
        for( var i = 0; i < PLAYERS; ++i ) {
            this.updateCurrentSoil(i);
            this.refreshPlayerSoilScreen(i);
            this.add.image(i * 320, 0, 'player-frame').setOrigin(0,0).setScale(4);
            this.add.image(i * 320, 432, 'next-soil').setOrigin(0,0).setScale(4).setDepth(888);
        }
        /*********************************************************************** */

        this.playersTextScore = new Array(PLAYERS);
        for(var i = 0; i < this.playersScore!.length; ++i) {
            this.playersTextScore![i] = this.add.text(i * 320 + 10, 10, "Score:" + this.playersScore![i], style);
        }

        this.playersStatus = new Array(PLAYERS);
        for(var i = 0; i < PLAYERS; ++i) {
            this.playersStatus![i] = this.add.text(i * 320 + 20, 60, "N/A", style2);
            this.playersStatus![i].setAlpha(0);
        }

        this.stains = new Array(PLAYERS - 1);
        for(var i = 0; i < this.stains.length; ++i) {
            this.stains[i] = this.add.image(0, 0, 'stain').setOrigin(0,0).setScale(4);
            this.stains[i].alpha = 0;
        }

        this.playersCanBeTarget = new Array(PLAYERS);
        for( var i = 0; i < PLAYERS; ++i ) {
            this.playersCanBeTarget[i] = true;
        }

        this.emitterHitO = this.add.particles('hit-o-part');
        this.emitterEatO = this.add.particles('destroy-o-part');
        this.emitterPowerup = this.add.particles('get-powerup');
    }

	preload(){
        // IMAGERY AND SOUND
        this.load.image('b-b', 'gfx/B-B.png');
        this.load.image('b-o', 'gfx/B-O.png');
        this.load.image('b-p', 'gfx/B-P.png');
        this.load.image('b-ra', 'gfx/B-RA.png');
        this.load.image('b-rp', 'gfx/B-RP.png');
        this.load.image('o-b', 'gfx/O-B.png');
        this.load.image('o-ra', 'gfx/O-RA.png');
        this.load.image('o-rp', 'gfx/O-RP.png');
        this.load.image('p-b', 'gfx/P-B.png');
        this.load.image('p-ra', 'gfx/P-RA.png');
        this.load.image('p-rp', 'gfx/P-RP.png');
        this.load.image('ra-b', 'gfx/RA-B.png');
        this.load.image('ra-o', 'gfx/RA-O.png');
        this.load.image('ra-p', 'gfx/RA-P.png');
        this.load.image('ra-ro-o', 'gfx/RA-RO-O.png');
        this.load.image('ra-ro-p', 'gfx/RA-RO-P.png');
        this.load.image('ra-ro', 'gfx/RA-RO.png');
        this.load.image('ro-ra-o', 'gfx/RO-RA-O.png');
        this.load.image('ro-ra-p', 'gfx/RO-RA-P.png');
        this.load.image('ro-ra', 'gfx/RO-RA.png');
        this.load.image('ro-rp-o', 'gfx/RO-RP-O.png');
        this.load.image('ro-rp-p', 'gfx/RO-RP-P.png');
        this.load.image('ro-rp', 'gfx/RO-RP.png');
        this.load.image('rp-b', 'gfx/RP-B.png');
        this.load.image('rp-o', 'gfx/RP-O.png');
        this.load.image('rp-p', 'gfx/RP-P.png');
        this.load.image('rp-ro-o', 'gfx/RP-RO-O.png');
        this.load.image('rp-ro-p', 'gfx/RP-RO-P.png');
        this.load.image('rp-ro', 'gfx/RP-RO.png');
        this.load.image('start', 'gfx/Start.png');
        this.load.image('player-frame', 'gfx/PlayerFrame.png');
        this.load.image('pu-swap', 'gfx/PUSwap.png');
        this.load.image('pu-thief', 'gfx/PUThief.png');
        this.load.image('pu-obfuscator', 'gfx/PUObfuscator.png');
        this.load.image('pu-coin', 'gfx/PUCoin.png');
        this.load.image('pu-freeze', 'gfx/PUFreeze.png');
        this.load.image('pu-irontip', 'gfx/PUIronTip.png');
        this.load.image('pu-shield', 'gfx/PUShield.png');
        this.load.image('stain', 'gfx/stain.png');
        this.load.image('next-soil', 'gfx/nextSoil.png');

        this.load.image('hit-o-part', 'gfx/hitobstacleparticle.png');
        this.load.image('destroy-o-part', 'gfx/breakobstacleparticle.png');
        this.load.image('get-powerup', 'gfx/getpowerupparticle.png');

        this.load.image('menu', 'gfx/menu.png');
    }

    update() {
        if(!menu) {
            for(var i = 0; i < this.playersKeyGroup!.length; ++i) {

                if(!this.playersCanAct![i]) {
                    this.playersStatus![i].setAlpha(1);
                    this.playersStatus![i].setText("FROZEN");
                }
                else if(this.playersKeyGroup![i].inverted) {
                    this.playersStatus![i].setText("INVERTED");
                    this.playersStatus![i].setAlpha(1);
                }
                else if(this.playersOnIronTip![i]) {
                    this.playersStatus![i].setText("IRON TIP");
                    this.playersStatus![i].setAlpha(1);
                }
                else if(!this.playersCanBeTarget![i]) {
                    this.playersStatus![i].setText(">SHIELD<");
                    this.playersStatus![i].setAlpha(1);
                }
                else {
                    this.playersStatus![i].setAlpha(0);
                }

                if(!this.playersCanAct![i]) continue;

                this.playersKeyGroup![i].update();

                if( this.playersKeyGroup![i].keyLeft.isPressed() || this.playersKeyGroup![i].keyRight.isPressed() || (inputQueue[i].length >0 && inputQueue[i][0] < 2)) {
                    var remoteKey = inputQueue[i][0];
                    switch( this.playersSoil![i][0] ) {

                        case SoilState.B_B:
                            this.updatePastSoil( i );              
                            
                            this.playersPreviousDirection![i] = this.playersCurrentDirection![i];
                            
                            if(this.playersKeyGroup![i].keyLeft.isPressed() || remoteKey == 0)
                                this.playersCurrentDirection![i] = Direction.LEFT;
                            else
                                this.playersCurrentDirection![i] = Direction.RIGHT;
                            
                            this.updateCurrentSoil( i );
                            
                            this.playersScore![i] += 10;

                            break;

                        case SoilState.O_B:
                            if( this.playersKeyGroup![i].keyLeft.isPressed() || remoteKey == 0) {
                                if(!this.playersOnIronTip![i]) {
                                    this.playersScore![i] -= 8;
                                    console.log("Errooooooou");
                                    var particles = this.add.particles('hit-o-part');
                                    particles.setDepth(889);
                                    var emitter = particles.createEmitter();
                                    emitter.setSpeed(30);
                                    emitter.setGravity(0, 2);
                                    emitter.setBlendMode(Phaser.BlendModes.ADD);
                                    emitter.explode(80, i * 320 + 68, 3 * 144 + 66);
                                }
                                else
                                {
                                    var particles = this.add.particles('destroy-o-part');
                                    particles.setDepth(889);
                                    var emitter = particles.createEmitter();
                                    emitter.setSpeed(200);
                                    emitter.setGravity(0, 2);
                                    emitter.setBlendMode(Phaser.BlendModes.ADD);
                                    emitter.explode(80, i * 320 + 68, 3 * 144 + 66);
                                    this.updatePastSoil( i );
                                    this.playersPreviousDirection![i] = this.playersCurrentDirection![i];
                                    this.playersCurrentDirection![i] = Direction.LEFT;
                                    this.updateCurrentSoil( i );
                                    this.playersScore![i] += 10;
                                }
                            }
                            else {
                                this.updatePastSoil( i );
                                this.playersPreviousDirection![i] = this.playersCurrentDirection![i];
                                this.playersCurrentDirection![i] = Direction.RIGHT;
                                this.updateCurrentSoil( i );
                                this.playersScore![i] += 10;
                            }
                            break;

                        case SoilState.B_O:
                            if( this.playersKeyGroup![i].keyRight.isPressed() || remoteKey == 1 ) {
                                if(!this.playersOnIronTip![i]) {
                                    console.log("Errooooooou");
                                    this.playersScore![i] -= 8;
                                    var particles = this.add.particles('hit-o-part');
                                    particles.setDepth(889);
                                    var emitter = particles.createEmitter();
                                    emitter.setSpeed(30);
                                    emitter.setGravity(0, 2);
                                    emitter.setBlendMode(Phaser.BlendModes.ADD);
                                    emitter.explode(80, (i+1) * 320 - 90, 3 * 144 + 66);
                                }
                                else {
                                    var particles = this.add.particles('destroy-o-part');
                                    particles.setDepth(889);
                                    var emitter = particles.createEmitter();
                                    emitter.setSpeed(200);
                                    emitter.setGravity(0, 2);
                                    emitter.setBlendMode(Phaser.BlendModes.ADD);
                                    emitter.explode(80, (i+1) * 320 - 68, 3 * 144 + 66);
                                    this.updatePastSoil( i );
                                    this.playersPreviousDirection![i] = this.playersCurrentDirection![i];
                                    this.playersCurrentDirection![i] = Direction.RIGHT;
                                    this.updateCurrentSoil( i );
                                    this.playersScore![i] += 10;    
                                }
                            }
                            else {
                                this.updatePastSoil( i );
                                this.playersPreviousDirection![i] = this.playersCurrentDirection![i];
                                this.playersCurrentDirection![i] = Direction.LEFT;
                                this.updateCurrentSoil( i );
                                this.playersScore![i] += 10;
                            }
                            break;

                        case SoilState.P_B:
                            this.updatePastSoil( i );
                            this.playersPreviousDirection![i] = this.playersCurrentDirection![i];
                            if( this.playersKeyGroup![i].keyLeft.isPressed() || remoteKey == 0 ) {
                                console.log("Ganhoooou POWERUP");
                                var particles = this.add.particles('get-powerup');
                                particles.setDepth(889);
                                var emitter = particles.createEmitter();
                                emitter.setSpeed(200);
                                emitter.setGravity(0, 2);
                                emitter.setBlendMode(Phaser.BlendModes.ADD);
                                emitter.explode(80, i * 320 + 68, 3 * 144 + 66);
                                this.randomizePowerup(i);
                                this.getPowerup(i);
                                this.playersCurrentDirection![i] = Direction.LEFT;
                            }
                            else
                                this.playersCurrentDirection![i] = Direction.RIGHT;
                            
                            this.updateCurrentSoil( i );
                            this.playersScore![i] += 10;
                            
                            break;

                        case SoilState.B_P:
                            this.updatePastSoil( i );
                            this.playersPreviousDirection![i] = this.playersCurrentDirection![i];
                            if( this.playersKeyGroup![i].keyRight.isPressed() || remoteKey == 1 ) {
                                console.log("Ganhoooou POWERUP");
                                this.randomizePowerup(i);
                                this.getPowerup(i);
                                this.playersCurrentDirection![i] = Direction.RIGHT;
                                var particles = this.add.particles('get-powerup');
                                particles.setDepth(889);
                                var emitter = particles.createEmitter();
                                emitter.setSpeed(200);
                                emitter.setGravity(0, 2);
                                emitter.setBlendMode(Phaser.BlendModes.ADD);
                                emitter.explode(80, (i+1) * 320 - 90, 3 * 144 + 66);
                            }
                            else
                                this.playersCurrentDirection![i] = Direction.LEFT;

                            this.updateCurrentSoil( i );
                            this.playersScore![i] += 10;
                            break;
                    }
                    inputQueue[i].shift();
                    // console.log(this.playersSoil![0].slice(0, 10));
                }
                else if(this.playersKeyGroup![i].keyExecute.isPressed() || (inputQueue[i].length >0 && inputQueue[i][0] == 2)) {
                    this.executePowerup(i);
                    inputQueue[i].shift();
                }
            }
            this.updateScore();
        }
        else
        {
            if(inited === true) {
                menu = false;
                this.menuImg!.destroy();
                this.fullCreate();
            }
        }   
    }

    updatePastSoil( player_index:number ) {
        if(this.playersPastSoil![player_index].length == 2) {
            this.playersPastSoil![player_index].splice(0, 1);
        }

        // if(!this.playersOnIronTip![player_index]) {    
            this.playersPastSoil![player_index].push( this.playersCurrentsoil![player_index] + 1 );
        // }
        // else
        // {
        //     var prevDir = this.playersPreviousDirection![player_index];
        //     var currDir = this.playersCurrentDirection![player_index];

        //     switch(this.playersCurrentsoil![player_index]) {
        //     }
        // }
    }

    updateCurrentSoil( player_index:number ) {
        var newCurrent = this.playersSoil![player_index][0];
        this.playersSoil![player_index].splice(0, 1);

        var prevDir = this.playersPreviousDirection![player_index];
        var currDir = this.playersCurrentDirection![player_index];

        switch( newCurrent ) {
            case SoilState.B_B:
                if( prevDir === currDir && prevDir === Direction.LEFT)
                    this.playersCurrentsoil![player_index] = SoilState.RA_B;
                else if(prevDir === currDir && prevDir === Direction.RIGHT)
                    this.playersCurrentsoil![player_index] = SoilState.B_RA;
                else if( prevDir === Direction.LEFT && currDir === Direction.RIGHT )
                    this.playersCurrentsoil![player_index] = SoilState.RO_RA;
                else
                    this.playersCurrentsoil![player_index] = SoilState.RA_RO;
                break;
            case SoilState.O_B:
                    if( prevDir === currDir && prevDir === Direction.RIGHT)
                        this.playersCurrentsoil![player_index] = SoilState.O_RA;
                    else if( prevDir === currDir && prevDir === Direction.LEFT && this.playersOnIronTip![player_index])
                        this.playersCurrentsoil![player_index] = SoilState.RA_B;
                    else if( prevDir === Direction.LEFT && currDir === Direction.RIGHT )
                        this.playersCurrentsoil![player_index] = SoilState.RO_RA_O;
                    else if( prevDir === Direction.RIGHT && currDir === Direction.LEFT && this.playersOnIronTip![player_index])
                        this.playersCurrentsoil![player_index] = SoilState.RA_RO;
                    break;
            case SoilState.P_B:
                if( prevDir === currDir && prevDir === Direction.LEFT)
                    this.playersCurrentsoil![player_index] = SoilState.RA_B;
                else if(prevDir === currDir && prevDir === Direction.RIGHT)
                    this.playersCurrentsoil![player_index] = SoilState.P_RA;
                else if( prevDir === Direction.LEFT && currDir === Direction.RIGHT )
                    this.playersCurrentsoil![player_index] = SoilState.RO_RA_P;
                else
                    this.playersCurrentsoil![player_index] = SoilState.RA_RO;
                break;
            case SoilState.B_O:
                if( prevDir === currDir && prevDir === Direction.LEFT)
                    this.playersCurrentsoil![player_index] = SoilState.RA_O;
                else if( prevDir === currDir && prevDir === Direction.RIGHT && this.playersOnIronTip![player_index])
                    this.playersCurrentsoil![player_index] = SoilState.B_RA;
                else if( prevDir === Direction.RIGHT && currDir === Direction.LEFT )
                    this.playersCurrentsoil![player_index] = SoilState.RA_RO_O;
                else if( prevDir === Direction.LEFT && currDir === Direction.RIGHT )
                    this.playersCurrentsoil![player_index] = SoilState.RO_RA;
                break;
            case SoilState.B_P:
                if( prevDir === currDir && prevDir === Direction.LEFT)
                    this.playersCurrentsoil![player_index] = SoilState.RA_P;
                else if(prevDir === currDir && prevDir === Direction.RIGHT)
                    this.playersCurrentsoil![player_index] = SoilState.B_RA;
                else if( prevDir === Direction.LEFT && currDir === Direction.RIGHT )
                    this.playersCurrentsoil![player_index] = SoilState.RO_RA;
                else
                    this.playersCurrentsoil![player_index] = SoilState.RA_RO_P;
                break;
        }

        this.refreshPlayerSoilScreen(player_index);
    }

    getPowerup(player_index:number) {
        
        switch(this.playersPowerup![player_index]) {
            case Powerups.NONE:
                break;
            case Powerups.SWAP_CONTROLS:
                this.playersImagePowerup![player_index] = this.add.image(player_index * 320 + 252, 72, 'pu-swap').setOrigin(0,0).setScale(4);
                break;
            case Powerups.COIN:
                this.playersImagePowerup![player_index] = this.add.image(player_index * 320 + 252, 72, 'pu-coin').setOrigin(0,0).setScale(4);
                break;
            // case Powerups.THIEF:
            //     this.playersImagePowerup![i] = this.add.image(i * 320 + 252, 72, 'pu-thief').setOrigin(0,0).setScale(4);
            //     break;
            case Powerups.SHIELD:
                this.playersImagePowerup![player_index] = this.add.image(player_index * 320 + 252, 72, 'pu-shield').setOrigin(0,0).setScale(4);
                break;
            case Powerups.FREEZE:
                this.playersImagePowerup![player_index] = this.add.image(player_index * 320 + 252, 72, 'pu-freeze').setOrigin(0,0).setScale(4);
                break;
            case Powerups.IRON_TIP:
                this.playersImagePowerup![player_index] = this.add.image(player_index * 320 + 252, 72, 'pu-irontip').setOrigin(0,0).setScale(4);
                break;
            case Powerups.OBFUSCATOR:
                this.playersImagePowerup![player_index] = this.add.image(player_index * 320 + 252, 72, 'pu-obfuscator').setOrigin(0,0).setScale(4);
                break;
        }
    }

    randomizePowerup( player_index:number) {
        if(this.playersImagePowerup![player_index] != null)
        this.playersImagePowerup![player_index].destroy();
        /**
         *  A- Swap Controls (5 seconds)
            B- Obfuscator (5 seconds)
            C- Freeze (3 seconds)
            D- Iron Tip (3 seconds)
            F- Shield (5 seconds)
            E- Thief
            G- Coin/Point

            Ranking by bitchiness:
            C, B, A, E, F, D, G

            Probabilities:
            A - 10%
            B - 10%
            C - 10%
            D - 20% 
            E - 5%
            F - 20%
            G - 25%
         */
        const maxRange1:number = 10;
        const maxRange2:number = 20;
        const maxRange3:number = 30;
        const maxRange4:number = 55;
        const maxRange5:number = 70;

        var p:number = Math.random() * 100;
        
        if( p <= maxRange1 ) { //A
            this.playersPowerup![player_index] = Powerups.SWAP_CONTROLS;
        }
        else if ( p < maxRange2 ) { //B
            this.playersPowerup![player_index] = Powerups.OBFUSCATOR;
        }
        else if( p < maxRange3 ) { //C
            this.playersPowerup![player_index] = Powerups.FREEZE;
        }
        else if( p < maxRange4 ) { // D
            this.playersPowerup![player_index] = Powerups.IRON_TIP;
        }
        else if( p < maxRange5 ) { //E
            this.playersPowerup![player_index] = Powerups.SHIELD;
        }
        else {
            this.playersPowerup![player_index] = Powerups.COIN;
        }
        // else { //G
        //     this.playersPowerup![player_index] = Powerups.THIEF;
        // }
    }

    refreshPlayerSoilScreen( player_index:number ) {
        switch(this.playersPastSoil![player_index].length) {
            case 0:
                break;
            case 1:
                this.addSoilAt( this.playersPastSoil![player_index][0], player_index * 320, 144 );
                break;
            case 2:
                this.addSoilAt( this.playersPastSoil![player_index][1], player_index * 320, 144 );
                // this.addSoilAt( this.playersPastSoil![player_index][0], player_index * 320, 0 );
                break;
        }

        this.addSoilAt( this.playersCurrentsoil![player_index], player_index * 320, 288 );
        this.addSoilAt( this.playersSoil![player_index][0], player_index * 320, 432 );
        this.addSoilAt( this.playersSoil![player_index][1], player_index * 320, 576 );
        
    }

    addSoilAt(soil:number, x:number, y:number) {
        switch(soil) {
            case SoilState.B_B: this.add.image(x, y, 'b-b').setOrigin(0,0).setScale(4); break;
            case SoilState.B_O: this.add.image(x, y, 'b-o').setOrigin(0,0).setScale(4); break;
            case SoilState.B_P: this.add.image(x, y, 'b-p').setOrigin(0,0).setScale(4); break;
            case SoilState.B_RA: this.add.image(x, y, 'b-ra').setOrigin(0,0).setScale(4); break;
            case SoilState.B_RP: this.add.image(x, y, 'b-rp').setOrigin(0,0).setScale(4); break;
            case SoilState.O_B: this.add.image(x, y, 'o-b').setOrigin(0,0).setScale(4); break;
            case SoilState.O_RA: this.add.image(x, y, 'o-ra').setOrigin(0,0).setScale(4); break;
            case SoilState.O_RP: this.add.image(x, y, 'o-rp').setOrigin(0,0).setScale(4); break;
            case SoilState.P_B: this.add.image(x, y, 'p-b').setOrigin(0,0).setScale(4); break;
            case SoilState.P_RA: this.add.image(x, y, 'p-ra').setOrigin(0,0).setScale(4); break;
            case SoilState.P_RP: this.add.image(x, y, 'p-rp').setOrigin(0,0).setScale(4); break;
            case SoilState.RA_B: this.add.image(x, y, 'ra-b').setOrigin(0,0).setScale(4); break;
            case SoilState.RP_B: this.add.image(x, y, 'rp-b').setOrigin(0,0).setScale(4); break;
            case SoilState.RA_O: this.add.image(x, y, 'ra-o').setOrigin(0,0).setScale(4); break;
            case SoilState.RA_P: this.add.image(x, y, 'ra-p').setOrigin(0,0).setScale(4); break;
            case SoilState.RA_RO_O: this.add.image(x, y, 'ra-ro-o').setOrigin(0,0).setScale(4); break;
            case SoilState.RP_RO_O: this.add.image(x, y, 'rp-ro-o').setOrigin(0,0).setScale(4); break;
            case SoilState.RA_RO_P: this.add.image(x, y, 'ra-ro-p').setOrigin(0,0).setScale(4); break;
            case SoilState.RP_RO_P: this.add.image(x, y, 'rp-ro-p').setOrigin(0,0).setScale(4); break;
            case SoilState.RA_RO: this.add.image(x, y, 'ra-ro').setOrigin(0,0).setScale(4); break;
            case SoilState.RP_RO: this.add.image(x, y, 'rp-ro').setOrigin(0,0).setScale(4); break;
            case SoilState.RO_RA_O: this.add.image(x, y, 'ro-ra-o').setOrigin(0,0).setScale(4); break;
            case SoilState.RO_RP_O: this.add.image(x, y, 'ro-rp-o').setOrigin(0,0).setScale(4); break;
            case SoilState.RO_RA_P: this.add.image(x, y, 'ro-ra-p').setOrigin(0,0).setScale(4); break;
            case SoilState.RO_RP_P: this.add.image(x, y, 'ro-rp-p').setOrigin(0,0).setScale(4); break;
            case SoilState.RO_RA: this.add.image(x, y, 'ro-ra').setOrigin(0,0).setScale(4); break;
            case SoilState.RO_RP: this.add.image(x, y, 'ro-rp').setOrigin(0,0).setScale(4); break;
            case SoilState.RP_O: this.add.image(x, y, 'rp-o').setOrigin(0,0).setScale(4); break;
            case SoilState.RP_P: this.add.image(x, y, 'rp-p').setOrigin(0,0).setScale(4); break;
            case SoilState.START: this.add.image(x, y, 'start').setOrigin(0,0).setScale(4); break;
        }
    }

    executePowerup(player_index:number) {
        switch(this.playersPowerup![player_index]) {
            case Powerups.NONE:
            // case Powerups.THIEF:
                break;
            case Powerups.SWAP_CONTROLS:
                for(var i = 0; i < PLAYERS; ++i) {
                    if( player_index === i || !this.playersCanBeTarget![i]) continue;
                    this.playersKeyGroup![i].invertSides();
                    this.time.delayedCall(5000, this.unswapControls, [], this);
                    this.playersPowerup![player_index] = Powerups.NONE;
                }
                break;
            case Powerups.FREEZE:
                for(var i = 0; i < PLAYERS; ++i) {
                    if( player_index === i || !this.playersCanBeTarget![i]) continue;
                    this.playersCanAct![i] = false;
                    this.time.delayedCall(5000, this.unfreeze, [], this);
                    this.playersPowerup![player_index] = Powerups.NONE;
                }
                break;
            case Powerups.COIN:
                this.playersScore![player_index] += 50;
                this.playersPowerup![player_index] = Powerups.NONE;
                this.updateScore();
                break;
            default:
                break;
            case Powerups.OBFUSCATOR:
                var stain:number = 0;
                for(var i = 0; i < PLAYERS; ++i) {
                    if( player_index === i || !this.playersCanBeTarget![i]) continue;
                    this.stains![stain].alpha = 1;
                    this.stains![stain].setDepth(999);
                    this.stains![stain].setPosition(i * 320, 0);
                    this.tweens.add({
                        targets: this.stains![stain],
                        alpha: 0.0,
                        duration: 5000,
                        delay: 1500
                    });
                    stain++;
                }
                this.playersPowerup![player_index] = Powerups.NONE;
                break;
            case Powerups.SHIELD:
                this.playersCanBeTarget![player_index] = false;
                this.time.delayedCall(5000, this.targetAgain, [player_index], this);
                this.playersPowerup![player_index] = Powerups.NONE;
                break;
            case Powerups.IRON_TIP:
                this.playersOnIronTip![player_index] = true;
                this.time.delayedCall(5000, this.noIronTip, [player_index], this);
                this.playersPowerup![player_index] = Powerups.NONE;
                break;
        }
        
        if(this.playersImagePowerup![player_index] != null)
            this.playersImagePowerup![player_index].destroy();
    }

    noIronTip(player_index:number) {
        this.playersOnIronTip![player_index] = false;
    }

    targetAgain(player_index:number) {
        this.playersCanBeTarget![player_index] = true;
    }

    updateScore() {
        for(var i = 0; i < this.playersScore!.length; ++i) {
            this.playersTextScore![i].setText( "Score:" + this.playersScore![i] );
        }
    }

    unfreeze() {
        for(var i = 0; i < this.playersCanAct!.length; ++i) {
            this.playersCanAct![i] = true;
        }
    }

    unswapControls() {
        for(var i = 0; i < this.playersKeyGroup!.length; ++i) {
            if(this.playersKeyGroup![i].inverted) this.playersKeyGroup![i].invertSides();
        }
    }
}
